import {ResourceData} from "../common/resource/resource-service";
import {IArea} from "./area-models";

export class AreaData extends ResourceData<IArea> {
    constructor() {
        super("/v5/areas");
    }
}
